<template>
    <span class="badge-private" v-if="isPrivateEnabled">Private</span>
</template>

<script>
export default {
	name: 'BadgePrivate',
	props: {
		isPrivateEnabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.badge-private {
	font-size: 10px;
	font-weight: 600;
	background-color: #FFD700;
	padding-left: 0.5rem !important;
	padding-right: 0.5rem !important;
	clip-path: polygon(0 0, 100% 0, 90% 50%, 100% 100%, 0 100%, 10% 50%);
}
</style>
